const stripHtmlToPlainText = (html) => {
  if (!html || typeof html !== "string") return "";

  const decoded = html
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

  return decoded.replace(/\s+/g, " ").trim();
};

/** Backend may set readMore=true even when the visible content is already complete. */
export const shouldShowPostReadMore = (postContent, readMoreFlag) => {
  if (readMoreFlag !== true) return false;

  const plainText = stripHtmlToPlainText(postContent);
  if (!plainText) return false;

  // Feed truncation is typically around 300–500 chars; short posts should not show the link.
  return plainText.length > 280;
};

export default shouldShowPostReadMore;
